var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-1"},[_c('app-input',{attrs:{"type":"checkbox","list":_vm.index},on:{"changed":_vm.setActivityStatusDone},model:{value:(_vm.checkboxValue),callback:function ($$v) {_vm.checkboxValue=$$v},expression:"checkboxValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }